import { useQuery } from '@tanstack/react-query';
import API from '../../../context/API';
import type { Schedule } from '../store/userStoresSlice';

export const STORE_SCHEDULES_QUERY_KEY = ['store-schedules'] as const;

export const useStoreSchedules = () => {
  return useQuery<Schedule[]>({
    queryKey: STORE_SCHEDULES_QUERY_KEY,
    queryFn: async () => {
      const res = await API.get('/schedules');
      return res.data || [];
    },
    staleTime: 5 * 60 * 1000,
  });
};
